<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>服务器管理</el-breadcrumb-item>
		</el-breadcrumb>
		<el-row class="box">
			<h3>{{date.factory}}私有云服务器磁盘容量使用情况</h3>
			<div class="display">
				<el-progress :text-inside="true" :stroke-width="26" :percentage="70"></el-progress>
			</div>
		</el-row>
		<el-divider></el-divider>
		<el-row class="box">
			<h3>{{date.factory}}私有云服务器历史数据</h3>
			<div class="display">
				<el-date-picker
						v-model="value1"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期">
				</el-date-picker>
				<el-button type="danger" style="margin-left: 50px">数据删除</el-button>
			</div>
		</el-row>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				date:[
					{
						factory:'xxx工厂'
					}
				]
			}
		}
	}
</script>
<style>
	.box{
		margin: 20px 50px 0 50px;
	}
	.display{
		margin: 0 50px 0 50px;
	}
</style>
